// Hàm định dạng tiền Việt Nam cho tất cả các trang
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
  }).format(amount);
};

// Hàm xử lý chuỗi mô tả nếu cần cắt ngắn (cho trang danh sách)
export const truncateDescription = (text, limit = 100) => {
  if (!text) return "";
  const cleanedText = text.replace(/<[^>]*>?/gm, ''); // Loại bỏ thẻ HTML
  return cleanedText.length > limit ? cleanedText.substring(0, limit) + "..." : cleanedText;
};